import React from 'react'

export interface AdminTabItem<T extends string = string> {
    value: T
    label: string
    icon?: string
}

interface AdminTabsProps<T extends string = string> {
    tabs: AdminTabItem<T>[]
    activeTab: T
    onChange: (value: T) => void
    className?: string
}

export function AdminTabs<T extends string = string>({ tabs, activeTab, onChange, className }: AdminTabsProps<T>) {
    return (
        <div className={`admin-tabs${className ? ` ${className}` : ''}`}>
            {tabs.map(tab => (
                <button
                    key={tab.value}
                    className={`tab-button${activeTab === tab.value ? ' active' : ''}`}
                    onClick={() => onChange(tab.value)}
                >
                    {tab.icon && <i className={tab.icon} />}
                    <span>{tab.label}</span>
                </button>
            ))}
        </div>
    )
}
